import { action as actionCreator } from "typesafe-actions";
import { asyncFailed, asyncHasFinished, asyncIsRunning, asyncNotStarted } from "@advosys/component-react-utils";
export var AboutDialogActionTypes;
(function (AboutDialogActionTypes) {
    AboutDialogActionTypes["GetAppServerVersionRequest"] = "@@UNIK:domains:application:components:main-layout:components:about-dialog:about-dialog-store:GetAppServerVersionRequest";
    AboutDialogActionTypes["GetAppServerVersionSuccess"] = "@@UNIK:domains:application:components:main-layout:components:about-dialog:about-dialog-store:GetAppServerVersionSuccess";
    AboutDialogActionTypes["GetAppServerVersionFail"] = "@@UNIK:domains:application:components:main-layout:components:about-dialog:about-dialog-store:GetAppServerVersionFail";
    AboutDialogActionTypes["Clear"] = "@@UNIK:domains:application:components:main-layout:components:about-dialog:about-dialog-store:Clear";
})(AboutDialogActionTypes || (AboutDialogActionTypes = {}));
export const actions = {
    getAppServerVersionRequest: () => actionCreator(AboutDialogActionTypes.GetAppServerVersionRequest),
    getAppServerVersionSuccess: (appServerVersion) => actionCreator(AboutDialogActionTypes.GetAppServerVersionSuccess, { appServerVersion }),
    getAppServerVersionFail: (errorMessage) => actionCreator(AboutDialogActionTypes.GetAppServerVersionFail, { errorMessage }),
    clear: () => actionCreator(AboutDialogActionTypes.Clear)
};
const initialState = {
    loading: asyncNotStarted
};
export const aboutDialogReducer = (state = initialState, action) => {
    switch (action.type) {
        case AboutDialogActionTypes.GetAppServerVersionRequest:
            return { ...state, loading: asyncIsRunning };
        case AboutDialogActionTypes.GetAppServerVersionSuccess:
            return { ...state, loading: asyncHasFinished({ appServerVersion: action.payload.appServerVersion }) };
        case AboutDialogActionTypes.GetAppServerVersionFail:
            return { ...state, loading: asyncFailed(action.payload.errorMessage) };
        case AboutDialogActionTypes.Clear:
            return initialState;
        default:
            return state;
    }
};
